// extracted by mini-css-extract-plugin
export var card = "PartnerCommunitySection-module__card___8uwZ+";
export var cardBody = "PartnerCommunitySection-module__cardBody___rFUgW";
export var cardDescription = "PartnerCommunitySection-module__cardDescription___JUwjK";
export var cardGrid = "PartnerCommunitySection-module__cardGrid___oI4D+";
export var cardLink = "PartnerCommunitySection-module__cardLink___WdwpA";
export var cardTitle = "PartnerCommunitySection-module__cardTitle___BSnx7";
export var contextualStoreBackgroundDark = "#1a1b1e";
export var icon = "PartnerCommunitySection-module__icon___x0dIs";
export var section = "PartnerCommunitySection-module__section___mtKII";
export var subtitle = "PartnerCommunitySection-module__subtitle___9UDH4";
export var title = "PartnerCommunitySection-module__title___bYglw";